import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import CollectionCard from "@/components/feature/CollectionCard";
import { collections, featuredIds } from "@/mocks/collections";

export default function FeaturedCollections() {
  const featured = collections.filter((c) => featuredIds.includes(c.id));

  return (
    <section className="bg-background-100">
      <div className="container-site py-14 md:py-20">
        <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <SectionTitle
            eyebrow="精选合集"
            title="本周热门整理贴"
            desc="以下合集按系列与作者整理，附章节目录，方便你顺着整理贴逐条收藏与补全。"
          />
          <Link
            to="/collections"
            className="mb-10 inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
          >
            查看全部合集
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((item) => (
            <CollectionCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}